import { render, staticRenderFns } from "./IntroductionToTheSociety.vue?vue&type=template&id=5fc8a982&scoped=true"
import script from "./IntroductionToTheSociety.vue?vue&type=script&lang=js"
export * from "./IntroductionToTheSociety.vue?vue&type=script&lang=js"
import style0 from "./IntroductionToTheSociety.vue?vue&type=style&index=0&id=5fc8a982&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc8a982",
  null
  
)

export default component.exports